// namespace
export const CONTACTS_NAMESPACE = 'contacts'

// getters
export const CONTACTS_GETTER = 'contacts'
export const CONTACTS_GETTER_GUESTLIST = 'guestlist'

// mutations
export const CONTACTS_MUTATION_SINGLE_ENTRY = 'updateContactsFromSingleEntry'
export const CONTACTS_MUTATION_ENTIRE_CONTACTS = 'updateEntireContacts'
export const CONTACTS_MUTATION_SINGLE_CONTACT = 'updateSingleContact'
export const CONTACTS_MUTATION_DELETE_CONTACT = 'deleteSingleContact'
export const CONTACTS_MUTATION_DELETE_ALL_CONTACTS = 'deleteAllContactsMutation'
export const CONTACTS_MUTATION_CREATE_CONTACT = 'addContact'

// actions
export const CONTACTS_ACTION_GET_CONTACTS = 'fetchContacts'
export const CONTACTS_ACTION_DELETE_CONTACT = 'deleteContact'
export const CONTACTS_ACTION_UPDATE_CONTACT = 'updateContact'
export const CONTACTS_ACTION_CREATE_CONTACT = 'createContact'
export const CONTACTS_ACTION_DELETE_ALL_CONTACTS = 'deleteAllContacts'



// WEBPACK FOOTER //
// ./src/store/modules/contacts-types.js